import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="121" height="120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M60.5 35V15h-50v90h100V35h-50zm-30 60h-10V85h10v10zm0-20h-10V65h10v10zm0-20h-10V45h10v10zm0-20h-10V25h10v10zm20 60h-10V85h10v10zm0-20h-10V65h10v10zm0-20h-10V45h10v10zm0-20h-10V25h10v10zm50 60h-40V85h10V75h-10V65h10V55h-10V45h40v50zm-10-40h-10v10h10V55zm0 20h-10v10h10V75z" fill="#8CAAAA" /></svg>);